import React, { useState } from "react";
import "./StudentEnquiryComponent.css";
import { FaQuestionCircle, FaPlus, FaPhoneAlt, FaCalendarAlt } from "react-icons/fa";

const StudentEnquiryComponent = () => {
  const [enquiries] = useState([
    { id: 1, parentName: "Sanjay Gupta", childName: "Ishani", classSought: "Nursery", phone: "98123 45678", status: "Follow-up Scheduled", date: "2026-04-12" },
    { id: 2, parentName: "Megha Nair", childName: "Aarush", classSought: "Playgroup", phone: "98234 56789", status: "Converted", date: "2026-04-08" },
  ]);

  return (
    <div className="enquiry-container">
      <div className="enquiry-header">
        <h2><FaQuestionCircle /> Admission Enquiries</h2>
        <button className="btn-primary"><FaPlus /> New Lead / Walk-in</button>
      </div>

      <div className="table-responsive">
        <table className="enquiry-table">
          <thead>
            <tr>
              <th>Parent Name</th>
              <th>Child Name</th>
              <th>Class Sought</th>
              <th>Contact Phone</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {enquiries.map((e) => (
              <tr key={e.id}>
                <td><strong>{e.parentName}</strong></td>
                <td>{e.childName}</td>
                <td>{e.classSought}</td>
                <td><FaPhoneAlt className="table-icon" /> {e.phone}</td>
                <td><span className="enquiry-status">{e.status}</span></td>
                <td><FaCalendarAlt className="table-icon" /> {e.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StudentEnquiryComponent;